import AlertDashboardChartController from './chart.controller';

const DashboardChartComponent = {
  template: require('./chart.html'),
  restrict: 'E',
  controller: AlertDashboardChartController
};

export default DashboardChartComponent;